import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./error-modal.module.css";
export function ErrorModal(param) {
    var validationErrors = param.validationErrors;
    if (!validationErrors || !Array.isArray(validationErrors) || validationErrors.length === 0) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.wrapper,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: styles.validationErrorTitle,
                    children: "Before publishing this review please address the errors"
                }),
                validationErrors.map(function(error, index) {
                    return /*#__PURE__*/ _jsx("p", {
                        className: styles.errorItem,
                        children: "".concat(index + 1, ". ").concat(error)
                    }, index);
                })
            ]
        })
    });
}
